/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '../../http/axios/index.js'
import getDefaultState from './moduleAuthState.js'

export default {
  SET_CURRENT_USER (state, user) {
    //noconsoleconsole.log('setting FB user')
    //noconsoleconsole.log(user)
    let newUser = {
      displayName: typeof user.displayName !== "undefined" ? user.displayName : state.firebaseUser.displayName,
      email: typeof user.email !== "undefined" ? user.email : state.firebaseUser.email,
      uid: typeof user.uid !== "undefined" ? user.uid : state.firebaseUser.uid,
      token: user.token
    }
    state.firebaseUser = newUser
    //noconsoleconsole.log(state.firebaseUser)
  },
  RESET_AUTH_STATE (state) {
    //noconsoleconsole.log('resetting auth state')
    Object.assign(state, getDefaultState())
  },
  SET_BEARER (state, accessToken) {
    //axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  SIGNOUT (state) {
    state.firebaseUser = false
  }
}
